// Redux store root. See docs/product/bugs/project-access-scoping-trd.md
// Section 2.4/R1 -- this path is reused (not new) from a prior, abandoned
// attempt at the same concern that left a dead, commented-out
// `import store from './utils/redux/redux_store'` scaffold in src/index.js.
import { configureStore } from '@reduxjs/toolkit';
import currentProjectReducer from './currentProjectSlice';

const store = configureStore({
  reducer: {
    currentProject: currentProjectReducer,
  },
});

export default store;
